import React from 'react';
import styles from './RMDTransactions.module.scss';
import { useSelector, useDispatch } from 'react-redux';

import {
  getExistingRMDinfo,
  getIsRMDBalanceAndAmountIsZero,
  getRMDAgreements,
} from '../../../redux/modules/RMD/RMDSetting.selectors';
import { getUserStateWithholdingRules } from '../../../redux/modules/stateWithholding/stateWithholding.selectors';
import {
  doesEverySystematicHaveAnAgreement,
  getIsRMDSpecialPayee,
  getIsRMDFundNonIRA,
  doesUserLEGoToTrust,
  getAllUserFunds,
} from '../../../redux/modules/UserFunds/userFunds.selectors';

import { TOLL_FREE_NUMBER } from '../../../settings/settings';
import { getExistingBanksInfo } from '../../../redux/modules/existingBanks/existingBanks.selectors';
import MyToolTip from '../../Shared/MyToolTip/MyToolTip';
import {
  AUTOMATIC_TRANSACTION_DELETE,
  openModal as openModalAction,
} from '../../../redux/modules/modals/modals.module';
import iconInfoIimg from '../../../assets/images/icon-questionmark-fill.svg';
import { currency } from '../../../utils/dashboard-utils';
import config from '../../../config/config';
import {
  isStateWithholding,
  printAgreementType,
  printFrequency,
  printFromData,
  printToData,
} from './RMDTransactionsUtil';
import Phone from '../../Phone/Phone';

const SellAndExchangeTransaction = ({
  systematic,
  title,
  url = 'usis/transactions/automatic/sell',
  type = 'REDEEM',
}) => {
  const dispatch = useDispatch();
  const sytematicsMatch = useSelector(doesEverySystematicHaveAnAgreement);
  const RMDBalanceAndAmountIsZero = useSelector(getIsRMDBalanceAndAmountIsZero);
  const isRMDSpecialPayee = useSelector(getIsRMDSpecialPayee);
  const isRMDFundNonIRA = useSelector(getIsRMDFundNonIRA);
  const userLETrust = useSelector(doesUserLEGoToTrust);
  const rmdIsHidden = useSelector(getExistingRMDinfo)?.some(
    (fund) => fund.hidden
  );
  const stateWithholdingData = useSelector(getUserStateWithholdingRules);

  const allFunds = useSelector(getAllUserFunds);
  const allBanks = useSelector(getExistingBanksInfo);
  const transactions = systematic?.filter((fund) =>
    allFunds.some(
      (ele) => fund.sourceAgreementKey.agreementID === ele.agreementID
    )
  );

  const showCallToEdit =
    userLETrust ||
    // RMDBalanceAndAmountIsZero ||
    isRMDSpecialPayee ||
    isRMDFundNonIRA ||
    !sytematicsMatch ||
    rmdIsHidden;

  return (
    <div className={styles['sell-exchange-transaction-container']} >
      <div className={styles['text-section']}>
        <>
          <div className={styles['title']}>
            <div className={styles['rmd-action-buttons-cons']}>
              <span>{title}</span>
              <div className={styles['rmd-action-buttons']}>
                {showCallToEdit && (
                  <MyToolTip
                    id={'Call-to-edit'}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        Please{' '}
                        <a
                          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                          rel="noopener noreferrer"
                          target="_blank"
                          className={styles['contact-us-link']}
                        >
                          contact us
                        </a>{' '}
                        to make changes to your Required Minimum Distribution.
                      </p>
                    }
                    callerNode={
                      <span className={styles['pending-trade']}>
                        Call to Edit
                      </span>
                    }
                    maxNoteWidth="300px"
                  />
                )}
              </div>
            </div>
          </div>
        </>
        <div className={styles['table-container']}>
          <table className={styles['table']}>
            <thead>
              <tr className={styles['table-title']}>
                <th className={styles['header']}>From</th>
                <th className={styles['header']}>To</th>
                <th className={styles['header']}>Frequency</th>
                <th className={styles['header']}>Withholding</th>
                <th className={styles['header-num']}>Amount</th>
                <th className={styles['header']}></th>
              </tr>
            </thead>
            {transactions?.map((fund, i) => (
              <tr className={styles['table-elements']}>
                <td className={styles['body']}>
                  <div className={styles['autosell-from']}>
                    <strong className={styles['fund-type']}>
                      {printFromData(
                        fund.sourceAgreementKey.agreementID,
                        'displayClassification'
                      )?.replace('_', '-')}{' '}
                      /{' '}
                      {printAgreementType(
                        printFromData(
                          fund.sourceAgreementKey.agreementID,
                          'agreementType'
                        )
                      )}
                    </strong>
                    <br />
                    <span className={styles['fund-name']}>
                      {printFromData(
                        fund.sourceAgreementKey.agreementID,
                        'fundName'
                      )}
                    </span>
                    <span className={styles['fund-ticker']}>
                      {printFromData(
                        fund.sourceAgreementKey.agreementID,
                        'ticker'
                      )}
                    </span>
                    <span className={styles['fund-ticker']}>
                      {fund?.accountNumber}-{fund.checkSum}
                    </span>
                  </div>
                </td>
                <td className={styles['body']}>
                  <div className={styles['autosell-from']}>
                    {printToData(fund, fund.sourceAgreementKey.agreementID)}
                  </div>
                </td>
                <td className={styles['account-name']}>
                  <span>{printFrequency(fund)}</span>
                  <MyToolTip
                    id={`rmd-frequency-${type}-` + fund.encryptedUniqueKey}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        Federal and applicable state income tax withholding will
                        apply. RMD will be recalculated every year.
                      </p>
                    }
                    callerNode={
                      <img
                        className={styles['tooltip-icon-frequency']}
                        src={iconInfoIimg}
                        alt="info-icon"
                      />
                    }
                    maxNoteWidth="300px"
                  />
                </td>
                <td className={styles['account-name']}>
                  <>
                    {fund.IRAWithholding > 0 && 'Federal: '}
                    {fund.IRAWithholding > 0 ? fund.IRAWithholding : 'Declined'}
                    {fund.IRAWithholding > 0 ? '%' : ''}
                    {isStateWithholding(fund) && (
                      <>
                        ; State:{' '}
                        {stateWithholdingData?.address === 'MN' &&
                          'Not available'}
                        {stateWithholdingData?.address !== 'MN' &&
                          stateWithholdingData.percent + '%'}
                      </>
                    )}
                  </>
                  <MyToolTip
                    id={`rmd-withdraw-${type}-` + fund.encryptedUniqueKey}
                    descriptionBody={
                      <p className={styles['desc-text']}>
                        The state withholding shown is the default amount per
                        your applicable state's rules. This may not reflect
                        individualized preferences (i.e. requested increased
                        amount or a W-4R exemption)
                      </p>
                    }
                    callerNode={
                      <img
                        className={styles['tooltip-icon']}
                        src={iconInfoIimg}
                        alt="info-icon"
                      />
                    }
                    maxNoteWidth="300px"
                  />
                </td>
                <td className={styles['num']}>{currency(fund.amount)}</td>
                {type !== 'rmd-details' &&
                (showCallToEdit || fund?.pendingTrade || fund?.pending) ? (
                  <td className={styles['num']}>
                    <MyToolTip
                      id={`update-pending-${type}-` + fund.encryptedUniqueKey}
                      descriptionBody={
                        <p className={styles['desc-text']}>
                          Update may take up to five business days to process.
                          Please call (800) 225-5132 to make changes.
                        </p>
                      }
                      callerNode={
                        <span className={styles['callerNode']}>
                          Update Pending
                        </span>
                      }
                      maxNoteWidth="250px"
                    />
                  </td>
                ) : (
                  <td>
                    <span className={styles['action-button-sell-exchange']}>
                      <a
                        className={styles['action-link']}
                        href={`${config.url}/${url}/edit?activityIDs=${fund.encryptedUniqueKey}`}
                      >
                        Edit
                      </a>
                      <div
                        className={styles['automatic-action-options-spacer']}
                      />
                      <a
                        className={styles['action-link']}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(
                            openModalAction(AUTOMATIC_TRANSACTION_DELETE, {
                              fund,
                              type: type,
                            })
                          );
                        }}
                      >
                        {' '}
                        Delete
                      </a>
                    </span>
                  </td>
                )}
              </tr>
            ))}
          </table>
        </div>
      </div>
    </div>
  );
};

export default SellAndExchangeTransaction;
